<template>
    <div class="view view--programs">
        <data-table
            class="has-margin-b45"
            v-bind:data="tableData"
            v-on:sort="sortDataTable"
        ></data-table>

        <btn
            class="is-success"
            type="default"
            href="/admin#/programs/create"
            v-html="__('+ Add program')"
        ></btn>

        <modal
            class="is-narrow"
            v-bind:title="__('Are you sure?')"
            v-bind:is-open="isOpenDeleteModal"
            v-on:close-modal="isOpenDeleteModal = false"
        >
            <template v-slot:body>
                <p
                    class="has-text-center"
                    v-html="
                        __(
                            'Are you sure you want to delete this program?<br />This action cannot be undone.<br /><br /><strong>Attention! If you delete this program, the attached campaign will be deleted too.</strong>'
                        )
                    "
                ></p>
            </template>
            <template v-slot:footer>
                <div class="has-padding-t10">
                    <div class="columns">
                        <div class="column">
                            <btn
                                class="is-block"
                                type="cancel"
                                v-html="__('Cancel')"
                                v-on:click="isOpenDeleteModal = false"
                            >
                            </btn>
                        </div>
                        <div class="column">
                            <btn
                                class="is-block"
                                type="error"
                                v-html="__('Delete')"
                                v-on:click="deleteProgram"
                            >
                            </btn>
                        </div>
                    </div>
                </div>
            </template>
        </modal>
    </div>
</template>

<script>
import MessageHandler from '../../messageHandler';
import store from '../../store';

import { Btn } from '@teamfurther/cinderblock';
import { DataTable } from '@teamfurther/cinderblock';
import { Modal } from '@teamfurther/cinderblock';
import ProgramRepository from '../../repositories/ProgramRepository';

export default {
    components: {
        Btn,
        DataTable,
        Modal
    },
    created: function() {
        this.programRepository = new ProgramRepository();
    },
    data: function() {
        return {
            deletingId: null,
            errors: {},
            isOpenDeleteModal: false,
            programRepository: null,
            programs: [],
            tableData: {
                columnNames: {
                    title: this.__('Title'),
                    shortDescription: this.__('Short description'),
                    startDate: this.__('Start date'),
                    endDate: this.__('End date'),
                    goal: this.__('Goal')
                },
                items: [],
                sortableColumns: ['title', 'startDate', 'endDate', 'goal']
            }
        };
    },
    methods: {
        deleteProgram: async function() {
            try {
                await this.programRepository.deleteProgram(this.deletingId);

                store.state.alerts.push(
                    new MessageHandler(
                        this.__('Program was successfully deleted.'),
                        this.__('Success.'),
                        'success'
                    )
                );

                await this.getPrograms();
            } catch (error) {
            } finally {
                this.isOpenDeleteModal = false;
            }
        },
        getPrograms: async function(sort = '') {
            try {
                this.programs = await this.programRepository.getPrograms(sort);

                let items = [];
                this.programs.forEach(program => {
                    items.push(this.transformProgramData(program));
                });

                this.$set(this.tableData, 'items', items);
            } catch (error) {}
        },
        showDeleteModal: function(data) {
            this.deletingId = data.id;
            this.isOpenDeleteModal = true;
        },
        transformProgramData: function(program) {
            let actions = [];

            actions.push({
                class: 'is-red',
                method: 'showDeleteModal',
                title: this.__('Delete')
            });
            actions.push({
                title: this.__('Edit'),
                url: '/admin#/programs/' + program.id + '/edit'
            });

            return {
                values: {
                    id: program.id,
                    endDate: program.end_at
                        ? new Intl.DateTimeFormat('hu').format(
                              new Date(program.end_at)
                          )
                        : null,
                    shortDescription:
                        program.short_description.length > 80
                            ? `${program.short_description.substring(0, 80)}...`
                            : program.short_description,
                    startDate: program.start_at
                        ? new Intl.DateTimeFormat('hu').format(
                              new Date(program.start_at)
                          )
                        : null,
                    title: program.title,
                    goal: program.goal
                },
                actions: actions
            };
        },
        sortDataTable: function(sortByColumn) {
            if (
                this.tableData.sortableColumns.includes(
                    sortByColumn.replace('-', '')
                )
            ) {
                this.getPrograms(sortByColumn);
            }
        }
    },
    mounted: function() {
        this.getPrograms();
    }
};
</script>
